/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import shareImageUrl from '../images/share.png';

SEO.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string,
	children: PropTypes.node,
};

export default function SEO({
	description = '',
	lang = 'en',
	meta = [],
	children,
}) {
	const { site, shareImage } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						author
					}
				}
				shareImage: file(name: { eq: "share" }) {
					childImageSharp {
						original {
							width
							height
						}
					}
				}
			}
		`
	);

	const metaDescription = description || site.siteMetadata.description;

	const title = site.siteMetadata.title;

	const shareImageSize = shareImage.childImageSharp.original;

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			meta={[
				{
					name: `description`,
					content: metaDescription,
				},
				{
					property: `og:title`,
					content: title,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					property: `og:image`,
					content: `https://drinktracker.app${shareImageUrl}`,
				},
				{
					property: `og:image:width`,
					content: `${shareImageSize.width}`,
				},
				{
					property: `og:image:height`,
					content: `${shareImageSize.height}`,
				},
				{
					property: `og:image:alt`,
					content: `Drinktracker: 1.18 drinks still in you, sober by 10:17 PM, and a chart of the night.`,
				},
				{
					property: 'og:url',
					content: 'https://drinktracker.app',
				},
				// X reads the og tags for title, description and image. These two have no
				// og equivalent, so they stay.
				{
					name: `twitter:card`,
					content: `summary_large_image`,
				},
				{
					name: `twitter:creator`,
					content: site.siteMetadata.author,
				},
			].concat(meta)}
		>
			{children}
		</Helmet>
	);
}
